import request from './request'

// 管理员登录
export function adminLogin(data) {
  return request({
    url: '/admin/auth/login',
    method: 'post',
    data
  })
}

// 获取当前登录管理员信息
export function getAdminProfile() {
  return request({
    url: '/admin/auth/me',
    method: 'get'
  })
}

export function getConfigs() {
  return request({
    url: '/admin/system/configs',
    method: 'get'
  })
}

export function updateConfigs(data) {
  return request({
    url: '/admin/system/configs',
    method: 'post',
    data
  })
}

export function getMenus(params) {
  return request({
    url: '/admin/system/menus',
    method: 'get',
    params
  })
}

export function createMenu(data) {
  return request({
    url: '/admin/system/menus',
    method: 'post',
    data
  })
}

export function updateMenu(id, data) {
  return request({
    url: `/admin/system/menus/${id}`,
    method: 'put',
    data
  })
}

export function deleteMenu(id) {
  return request({
    url: `/admin/system/menus/${id}`,
    method: 'delete'
  })
}

export function getRoles(params) {
  return request({
    url: '/admin/system/roles',
    method: 'get',
    params
  })
}

export function createRole(data) {
  return request({
    url: '/admin/system/roles',
    method: 'post',
    data
  })
}

export function updateRole(id, data) {
  return request({
    url: `/admin/system/roles/${id}`,
    method: 'put',
    data
  })
}

export function deleteRole(id) {
  return request({
    url: `/admin/system/roles/${id}`,
    method: 'delete'
  })
}

export function getAdmins(params) {
  return request({
    url: '/admin/system/admins',
    method: 'get',
    params
  })
}

export function createAdmin(data) {
  return request({
    url: '/admin/system/admins',
    method: 'post',
    data
  })
}

export function updateAdmin(id, data) {
  return request({
    url: `/admin/system/admins/${id}`,
    method: 'put',
    data
  })
}

export function deleteAdmin(id) {
  return request({
    url: `/admin/system/admins/${id}`,
    method: 'delete'
  })
}

export function getOperationLogs(params) {
  return request({
    url: '/admin/system/operation-logs',
    method: 'get',
    params
  })
}

export function getLoginLogs(params) {
  return request({
    url: '/admin/system/login-logs',
    method: 'get',
    params
  })
}

export function getEnums() {
  return request({
    url: '/admin/system/enums',
    method: 'get'
  })
}

// 查询后台是否已初始化（admin 表是否有记录）
export function getInstallStatus() {
  return request({
    url: '/admin/install/status',
    method: 'get'
  })
}

// 首次安装：创建超级管理员角色与首个管理员账号
export function installAdmin(data) {
  return request({
    url: '/admin/install',
    method: 'post',
    data
  })
}